import { Checkbox, Col, Form, Input, Row, Select,message,Alert } from "antd";
import React ,{ useState } from "react";
import MaskedInput from "react-text-mask";
import { MASK_CEP, MASK_ZIP_CODE, removeMask } from "../../../helper/mask";

import { Permissions } from "../../../Constantes/permissions.constants";
import useSecurityContext from "../../../component/Security/useSecurityContext";
import services from "./../services";
import InputOrSearch from "./Input-search";

const buildPath = (prefix, field) =>
  Array.isArray(prefix) ? [...prefix, field] : [prefix, field];


const statusAlert = {
  warn: { tipo: "warning", titulo: "Aviso" },
};

const BRASIL = "BRASIL";
const Endereco = ({ nome, form, status,modoSomenteLeitura }) => {
  const [opcoesUf, setOpcoesUf] = React.useState([]);
  const [opcoesPais, setOpcoesPais] = React.useState([]);
  const [opcoesCidade, setOpcoesCidade] = React.useState([]);
  const { hasPermission } = useSecurityContext();
  const [brasilSelecionado, setBrasilSelecionado] = React.useState(true);
  const [cepEncontrado, setCepEncontrado] = React.useState(true);
  const [ufSelecionada, setUfSelecionada] = React.useState(false);
  const [cidadeSelecionada, setCidadeSelecionada] = React.useState(false);

  const [logradouroEncontrado, setLogradouroEncontrado] = React.useState(false);

  const [opcoesBairro, setOpcoesBairro] = React.useState([]);

  const [erroCEP, setErroCEP] = useState(false);

  const [semNumero, setSemNumero] = React.useState(false);

  const setFormValue = (form, path, value) => {
    if (!Array.isArray(path)) path = [path];

    const lastKey = path[path.length - 1];
    const nestedObj = path
      .slice(0, -1)
      .reduceRight((acc, key) => ({ [key]: acc }), { [lastKey]: value });

    form.setFieldsValue(nestedObj);
  };

  const getPermissaoPais = () =>
    hasPermission({ hasAnyRole: Permissions.RECADASTRAMENTO.TODOS_PAIS });

  const carregarOpcoesUf = () => {
    services
      .obterUF("")
      .then((response) => response?.data)
      .then((data) =>
        data?.map(({ id, sigla }) => ({ value: sigla, label: sigla }))
      )
      .then(setOpcoesUf);
  };

  /*const carregarOpcoesCidade = (uf) => {
    services
      .obterCidades(uf)
      .then((response) => response.data.content)
      .then((data) =>
        data.map(({ id, nome }) => ({ value: nome, label: nome,id:id }))
      )
      .then(setOpcoesCidade);
  };*/

  const carregarOpcoesCidade = (uf) => {
    services
      .obterCidades(uf)
      .then((response) => response.data.content)
      .then((data) => mapCidadeToOptions(data))
      .then(setOpcoesCidade);
  };

  const carregarOpcoesPais = () => {
    if (getPermissaoPais()) {
      services
        .obterPais()
        .then((response) => response.data)
        .then((data) => data.map(({ nome }) => ({ value: nome, label: nome })))
        .then(setOpcoesPais)
        .catch(console.error);
    } else {
      setOpcoesPais([{ value: BRASIL, label: BRASIL }]);
    }
  };

  const handleConsultaCep = (e) => {
    const cep = removeMask(e.target.value);

    if (brasilSelecionado && cep.length === 8) {
      setErroCEP(false);

      carregarCEP(cep).catch(() => {
        limparEnderecoExcetoCepEPais();

        setCepEncontrado(false);
        setUfSelecionada(false);
        setCidadeSelecionada(false);

        setErroCEP(true);
      });
    }
  };

  const limparEnderecoExcetoCepEPais = () => {
    const campos = [
      "logradouro",
      "complemento",
      "uf",
      "descricaoUF",
      "cidade",
      "bairro",
      "quadra",
      "lote",
      "numero",
    ];
  
    campos.forEach((campo) => {
      setFormValue(form, buildPath(nome, campo), null);
    });
  };

  const carregarCEP = (valor) => {
    return services.getEndereco(valor).then((endereco) => {
      setCepEncontrado(true);
     const tipo = endereco.tipo?.trim() ?? "";
     const nomeLogradouro = endereco.logradouro?.trim() ?? "";

     const logradouro = `${tipo} ${nomeLogradouro}`.trim();

     if(logradouro){
        setLogradouroEncontrado(true);
     }else{
      setLogradouroEncontrado(false);
     }

      setFormValue(form, buildPath(nome, "logradouro"), logradouro);
      setFormValue(form, buildPath(nome, "uf"), endereco.uf);
      setFormValue(form, buildPath(nome, "cidade"), endereco.cidade);
      setFormValue(form, buildPath(nome, "bairro"), endereco.bairro); // string
    });
  };

  const controleInicialCEP = (valor) => {
    if (valor !== undefined && valor.length === 8) {
      carregarCEP(valor).catch(() => {
        setCepEncontrado(false);
        carregarOpcoesCidade(form.getFieldValue(buildPath(nome, "uf")));
        setUfSelecionada(true);
        setCidadeSelecionada(true);
      });
    }
  };

  const controleInicialPais = (valor) => {
    // Se valor vier vazio, tentar selecionar Brasil
    if (!valor && opcoesPais.length > 0) {
      const paisBrasil = opcoesPais.find(
        (pais) => pais.value.toUpperCase() === BRASIL
      );
      if (paisBrasil) {
        form.setFieldsValue({ [nome]: { pais: paisBrasil.value } });
        setBrasilSelecionado(true);
        return;
      }
    }

    if (valor === BRASIL) setBrasilSelecionado(true);
    else setBrasilSelecionado(false);
  };

  // useEffect para quando a lista de países mudar
  React.useEffect(() => {
    if (opcoesPais.length > 0) {
      controleInicialPais(form.getFieldValue(buildPath(nome, "pais")));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opcoesPais]);

  const resetarCamposEndereco = () => {
    const campos = {
      cep: "",
      logradouro: "",
      complemento: "",
      uf: "",
      descricaoUF:"",
      cidade: "",
      bairro: "",
      quadra: "",
      lote: "",
      numero: "",
    };
    setLogradouroEncontrado(false);

    Object.entries(campos).forEach(([key, value]) => {
      setFormValue(form, buildPath(nome, key), value);
    });
  };

  const handleAlteracaoPais = (value) => {
    if (value === undefined || value === BRASIL) setBrasilSelecionado(true);
    else setBrasilSelecionado(false);
    resetarCamposEndereco();
    setCepEncontrado(true);
  };

  /*const handleAlteracaoUF = (value) => {
    if (brasilSelecionado) {
      setUfSelecionada(true);
      carregarOpcoesCidade(value);
    }
  };*/

  const handleAlteracaoUF = (value) => {
    if (brasilSelecionado) {
      setFormValue(form, buildPath(nome, "cidade"), null);
      setFormValue(form, buildPath(nome, "bairro"), null);
  
      setOpcoesCidade([]);
      setOpcoesBairro([]);
  
      setCidadeSelecionada(false);
      setLogradouroEncontrado(false);
  
      carregarOpcoesCidade(value);
      setUfSelecionada(true);
    }
  };

  /*const handleAlteracaoCidade = (value,option) => {
    if (brasilSelecionado) {
      setCidadeSelecionada(true);

      carregarOpcoesBairro(option || value);
    }
  };*/

  const handleAlteracaoCidade = (value, option) => {
    if (brasilSelecionado) {
      setFormValue(form, buildPath(nome, "bairro"), null);
      setOpcoesBairro([]);
  
      setCidadeSelecionada(true);
  
      const nomeCidade = option?.label;
  
      const id = value.split("__")[1];
  
      carregarOpcoesBairro(option);
  
      setFormValue(form, buildPath(nome, "cidadeNome"), nomeCidade);
    }
  };

  React.useEffect(() => {
    controleInicialPais(form.getFieldValue(buildPath(nome, "pais")));
  }, [status]);

  React.useEffect(() => {
    if (brasilSelecionado)
      controleInicialCEP(form.getFieldValue(buildPath(nome, "cep")));
  }, [brasilSelecionado]);

  React.useEffect(() => {
    carregarOpcoesUf();
    carregarOpcoesPais();
  }, []);

  const inicializado = React.useRef(false);

  React.useEffect(() => {
    if (inicializado.current) return;
  
    const numeroAtual = (form.getFieldValue(buildPath(nome, "numero")) || "")
      .toString()
      .trim()
      .toUpperCase();
  
    const semNum = ["", "S/N", "SEM NUMERO", "SEM NÚMERO", "SEM"].includes(numeroAtual);
  
    setSemNumero(semNum);
  
    if (semNum) {
      form.setFieldValue(buildPath(nome, "numero"), "S/N");
    }
  
    inicializado.current = true;
  }, []);

  const getLista = (response) =>
    response?.data?.content || response?.data || [];
  
  const mapToOptions = (data) =>
    data.map(({ id, nome }) => ({
      value: nome,
      label: nome,
    }));
  
  const carregarOpcoesBairro = async (option) => {
    const cidadeId = option?.id || null;
    const nomeCidade = option?.value?.split("__")[0] || null;
  
    try {
      let response = await services.obterBairros(cidadeId);
      let data = getLista(response);
  
      if (!data.length) {
        response = await services.obterBairrosBancoGprev(nomeCidade);
        data = getLista(response);
      }
  
      setOpcoesBairro(mapToOptions(data));
    } catch (e) {
      try {

        const response = await services.obterBairrosBancoGprev(nomeCidade);
        const data = getLista(response);
  
        setOpcoesBairro(mapToOptions(data));
      } catch {
        setOpcoesBairro([]);
      }
    }
  };

  const mapCidadeToOptions = (data) =>
    data.map(({ id, nome }) => ({
      value: `${nome}__${id}`,
      label: nome,
      id: id,
    }));

  return (
    <div>
      <Row>

      {erroCEP && (
        <Col span= {24}>
            <Alert
            message="Cep não encontrado na base de dados. Preencha o endereço selecionando com atenção a cidade e bairro."
            type="warning"
            showIcon
            onClose={() => setErroCEP(false)}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
              marginBottom: 16,
            }}
          />
        
        </Col>
          
        )}
        <Col span={4}>
          <Form.Item
            name={buildPath(nome, "pais")}
            label="País"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Selecione..."
              options={opcoesPais}
              showSearch
              onChange={handleAlteracaoPais}
            />
            {/*<Select
              options={[{ value: BRASIL, label: BRASIL }]}
              disabled
            />*/}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={buildPath(nome, "cep")}
            label={brasilSelecionado ? "CEP" : "ZIP Code"}
            rules={[
              { required: true },
              { validator: brasilSelecionado ? Endereco.Validator : null },
            ]}
          >
            <MaskedInput
              type="text"
              guide={false}
              autoComplete="off"
              mask={brasilSelecionado ? MASK_CEP : MASK_ZIP_CODE}
              className="ant-input"
              disabled={modoSomenteLeitura}
              onBlur={handleConsultaCep}
            />
          </Form.Item>
        </Col>
        <Col span={14}>
          <Form.Item
            name={buildPath(nome, "logradouro")}
            label="Endereço"
            preserve={true}
            rules={[{ required: true }, { type: "string", max: 255 }]}
          >
            <Input
              type="text"
              maxLength="300"
              disabled={cepEncontrado && brasilSelecionado && logradouroEncontrado}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            name={buildPath(nome, "complemento")}
            label="Complemento"
            rules={[{ required: true }, { max: 255 }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item
            name={buildPath(nome, "uf")}
            label="UF"
            rules={[{ required: true }, { max: 2 }]}
          >
            <InputOrSearch
              options={opcoesUf}
              disabled={cepEncontrado && brasilSelecionado}
              onChange={handleAlteracaoUF}
              showSearch
              showInput={!brasilSelecionado}
            />
          </Form.Item>
        </Col>

        {(!brasilSelecionado || erroCEP) && (
          <Col span={6}>
            <Form.Item
              name={buildPath(nome, "descricaoUF")}
              label="Descrição Unidade Federativa"
              rules={[{ required: true, message: "Informe a descrição da Unidade Federativa" }]}
            >
              <Input  disabled={cepEncontrado && brasilSelecionado} type="text" />
            </Form.Item>
          </Col>
        )}

        <Col span={6}>
          <Form.Item
            name={buildPath(nome, "cidade")}
            label="Cidade"
            rules={[{ required: true }]}
          >
            <InputOrSearch
              placeholder="Selecione a Cidade"
              options={opcoesCidade}
              disabled={(cepEncontrado || !ufSelecionada) && brasilSelecionado}
              onChange={handleAlteracaoCidade}
              showSearch
              showInput={!brasilSelecionado}
            />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={buildPath(nome, "bairro")}
            label="Bairro"
            rules={[{ required: true }, { max: 72 }]}
          >
            <InputOrSearch
              placeholder="Selecione o Bairro"
              options={opcoesBairro}
              disabled={(cepEncontrado || !cidadeSelecionada) && brasilSelecionado}
              showSearch
              showInput={!brasilSelecionado}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            name={buildPath(nome, "quadra")}
            label="Quadra"
            rules={[{ required: true }, { max: 255 }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>

        <Row gutter={16}>
          {/* Lote */}
          <Col span={12}>
            <Form.Item
              name={buildPath(nome, "lote")}
              label={
                <span>
                  Lote <span style={{ color: "red" }}>**</span>
                </span>
              }
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const numero = getFieldValue(buildPath(nome, "numero"));
                    if (numero === "S/N" && !value) {
                      return Promise.reject(
                        new Error("Lote obrigatório quando Número for S/N")
                      );
                    }
                    if (!value && (!numero || numero === "")) {
                      return Promise.reject(
                        new Error("Informe Lote ou Número")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                onBlur={() => {
                  form.validateFields([
                    buildPath(nome, "numero"),
                    buildPath(nome, "lote"),
                  ]);
                }}
              />
            </Form.Item>
          </Col>

          {/* Número */}
          <Col span={12}>
            <Form.Item
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span>
                    Número <span style={{ color: "red" }}>**</span>
                  </span>
                  <Checkbox
                    checked={semNumero}
                    onChange={(e) => {
                      const marcado = e.target.checked;
                      setSemNumero(marcado);

                      // Se marcado, define o valor "S/N", senão limpa
                      form.setFieldValue(
                        buildPath(nome, "numero"),
                        marcado ? "S/N" : ""
                      );

                      // Valida campos
                      form.validateFields([
                        buildPath(nome, "numero"),
                        buildPath(nome, "lote"),
                      ]);
                    }}
                  >
                    S/N
                  </Checkbox>
                </div>
              }
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const lote = getFieldValue(buildPath(nome, "lote"));
                    if ((!value || value === "") && (!lote || lote === "")) {
                      return Promise.reject(
                        new Error("Informe Lote ou Número ou Marque a opção S/N se não possuir número")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              {!semNumero && (
                <Form.Item
                  name={buildPath(nome, "numero")}
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "Informe Lote ou Número ou Marque a opção S/N se não possuir número",
                    },
                  ]}
                >
                  <Input
                    maxLength={10}
                    value={form.getFieldValue(buildPath(nome, "numero")) || ""}
                    onChange={(e) => {
                      // Permite apenas números se checkbox não estiver marcado
                      if (!semNumero) {
                        const somenteNumeros = e.target.value.replace(
                          /\D/g,
                          ""
                        );
                        form.setFieldValue(
                          buildPath(nome, "numero"),
                          somenteNumeros
                        );
                      }
                    }}
                    onBlur={() =>
                      form.validateFields([
                        buildPath(nome, "numero"),
                        buildPath(nome, "lote"),
                      ])
                    }
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

Endereco.Validator = (_, value = "") =>
  value.replace(/\D/g, "").length < 8 && value.replace(/\D/g, "").length > 0
    ? Promise.reject(new Error("CEP Incorreto"))
    : Promise.resolve();

export default Endereco;
